import { jsx as s } from "react/jsx-runtime";
import { useState as A, useEffect as B } from "react";
import { useSelector as p } from "react-redux";
import { S as _ } from "./myAccountProfileUtils-1642ffce.mjs";
import { useMyAccount as I } from "./utils/myAccountHook.js";
import { p as O } from "./helper-bf315385.mjs";
import b from "./components/AccountInformation/AccountInformation.js";
import './assets/CoApplicantProfile.css';const P = {
  Applicant: "APPLICANT",
  Owner: "OWNER",
  BusinessManager: "BUSINESS_MANAGER"
}, y = "#ffffff", S = "#396e75", w = "#e5fdff", G = "#546223", N = "#f0fae5", R = "#a65523", W = "#fff1e8", D = "#7f3e3e", E = "#ffe2e2", T = "#62625a", Y = "#f8f8e7", v = "#38539a", x = "#707070", M = "#c8f8d1", L = "#87c9c8", j = "#5291b1", F = "rgba(82, 145, 177, 0.1019607843)", U = "#445685", q = "#181d61", H = "rgba(24, 29, 97, 0.1019607843)", J = "#5969d6", K = "#ea999d", Q = "#b6577e", X = "rgba(182, 87, 126, 0.1019607843)", Z = "#7e3e80", $ = "#1e247f", aa = "rgba(30, 36, 127, 0.1019607843)", oa = "#da7600", ta = "#107f47", na = "#d91734", ra = "_html_e07kl_46", ea = {
  amwayWhite: y,
  darkBlue: S,
  lightBlue: w,
  darkGreen: G,
  lightGreen: N,
  darkOrange: R,
  lightOrange: W,
  darkRed: D,
  lightRed: E,
  darkYellow: T,
  lightYellow: Y,
  darkPurple: v,
  darkGrayOnWhite: x,
  dataVizColor1: M,
  dataVizColor2: L,
  dataVizColor3: j,
  dataVizColor3Background: F,
  dataVizColor4: U,
  dataVizColor5: q,
  dataVizColor5Background: H,
  dataVizColor6: J,
  dataVizColor7: K,
  dataVizColor8: Q,
  dataVizColor8Background: X,
  dataVizColor9: Z,
  dataVizColor10: $,
  dataVizColor10Background: aa,
  dataVizAlertOrange: oa,
  dataVizSuccessGreen: ta,
  dataVizWarningRed: na,
  "no-visible": "_no-visible_e07kl_42",
  html: ra,
  "co-app-profile-container": "_co-app-profile-container_e07kl_80",
  "skeleton-loading": "_skeleton-loading_e07kl_1"
}, za = () => {
  const { t: n, profileId: r, getCoAppConfig: g, setConfig: C, fetchCoAppData: z, aboNum: e } = I(), c = g(), V = p((a) => a.commerceProfile.registrationFlowData), { userData: u } = V, { partnerAccounts: d } = u, [m, k] = A("");
  B(() => {
    C(c);
    const a = O(f(d, r));
    k(a), z(a, e);
  }, [d, r]);
  const f = (a, h) => {
    var i, l;
    const t = a == null ? void 0 : a.find((o) => (o == null ? void 0 : o.profileId) === h);
    return t != null && t.primary ? (i = a == null ? void 0 : a.find((o) => !(o != null && o.primary) && (o == null ? void 0 : o.roleCode) === P.Owner)) == null ? void 0 : i.profileId : (l = a == null ? void 0 : a.find((o) => o == null ? void 0 : o.primary)) == null ? void 0 : l.profileId;
  };
  return /* @__PURE__ */ s("div", { className: ea["co-app-profile-container"], children: /* @__PURE__ */ s(
    b,
    {
      masterDataConfig: c,
      sliceName: _.CO_APP,
      profileId: m,
      accountNumber: e,
      screenTitle: n("profile.coApp.screenTitle"),
      editButtonText: n("profile.coApp.button.edit")
    }
  ) });
};
export {
  za as C,
  P as n
};
//# sourceMappingURL=CoApplicantProfile-d56c5a04.mjs.map
